import React, { FC } from "react";
import { Typography } from "@material-ui/core";

interface Props {
  title: string;
}

const NoMemoTitle: FC<Props> = (props: Props) => {
  return (
    <Typography variant={"h1"} data-test="title">
      {props.title}
    </Typography>
  );
};

export const Title = React.memo(NoMemoTitle);
